<div class="content-wrapper">
  <div class="illustration">
    <div class="bg">
      <img src="assets/img/undraw_under_construction_v2.svg" alt="under construction icon" />
    </div>
  </div>
  <div class="content">
    <div class="title">Coming soon</div>
    @if (title) {
      <p>Das Training '{{title}}' ist noch nicht fertig, wird aber in Zukunft verfügbar sein!</p>
    }
    @if (!title) {
      <p>Dieses Training ist noch nicht fertig, wird aber in Zukunft verfügbar sein!</p>
    }
    <button mat-flat-button color="primary" (click)="backClicked()">Zurück</button>
  </div>
</div>
